// extracted by mini-css-extract-plugin
export default {"symbol":"symbol--K8R9g7a1"};